/**
 * The legal identity behind Progsity, in one place.
 *
 * Every surface that names the company reads from here (footer, contact page,
 * policies, Organization JSON-LD) so the address, phone and emails can never
 * disagree with each other. Copy files carry the sentences, never these facts.
 */
export const COMPANY = {
  /** Exactly as registered with the RJSC, period included. */
  legalName: "BWJ Tech Ltd.",
  registrationNo: "C-209121/2026",
  /** The canonical host: the apex answers a 307 to this one. */
  website: "https://www.bwjtech.com/",
  addressLines: ["128/2 East Tejturi Bazar, Tejgaon", "Dhaka 1215, Bangladesh"] as const,
  address: {
    streetAddress: "128/2 East Tejturi Bazar, Tejgaon",
    addressLocality: "Dhaka",
    postalCode: "1215",
    addressCountry: "BD",
  },
  phoneDisplay: "+880 1844-287496",
  phoneTel: "+8801844287496",
  /** The same number on WhatsApp, digits only, as `wa.me` wants it. */
  whatsapp: "8801844287496",
  emails: {
    support: "support@progsity.io",
  },
} as const;
